import React from 'react'

function Ninth() {
  return (
    <section className='nine'>
        <div className="left">

        </div>
        
        <div className="right">
            <h1>Free Transfers & Low Cross-border Rates</h1>
            <p>More money stays in your pocket, and more money arrives in theirs.</p>
        </div>
    </section>
  )
}

export default Ninth